import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@mui/material/Typography';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../../../Atoms';

const useStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: '1 1 15%',
    textOverflow: 'ellipsis',
    gap: '4px',
  },
  valueStyle: {
    fontWeight: 600,
    letterSpacing: '0.02em',
  },
  captionStyle: {
    fontSize: '0.85rem',
    letterSpacing: '0.02em',
    fontWeight: 450,
  },
});

const Information = function Information({
  caption = '',
  value = '',
  inverted = false,
  styles = {},
  noWrap = true,
}) {
  const classes = useStyles();
  const intl = useIntl();
  const themeMode = useAtomValue(themeAtom);

  return (
    <div style={{ ...classes.root, ...styles.root }}>
      {!inverted ? (
        <>
          {typeof caption === 'string' ? (
            <Typography
              title={caption}
              sx={{
                color: themeMode === 'light' ? 'greys.darker' : 'greys.lighter',
                ...classes.captionStyle,
                ...styles.captionStyle,
              }}
              noWrap={noWrap}
            >
              {caption}
            </Typography>
          ) : (
            caption
          )}
          {typeof value === 'string' || !value ? (
            <Typography
              sx={{ ...classes.valueStyle, ...styles.valueStyle }}
              title={value || intl.messages.UNAVAILABLE}
              noWrap={noWrap}
            >
              {value || intl.messages.UNAVAILABLE}
            </Typography>
          ) : (
            value
          )}
        </>
      ) : (
        <>
          {typeof value === 'string' || !value ? (
            <Typography
              sx={{ ...classes.valueStyle, ...styles.valueStyle }}
              title={value || intl.messages.UNAVAILABLE}
              noWrap={noWrap}
            >
              {value || intl.messages.UNAVAILABLE}
            </Typography>
          ) : (
            value
          )}
          {typeof caption === 'string' ? (
            <Typography
              title={caption}
              sx={{ ...classes.captionStyle, ...styles.captionStyle }}
              noWrap
            >
              {caption}
            </Typography>
          ) : (
            caption
          )}
        </>
      )}
    </div>
  );
};

export default Information;
